export default function Smiley({ color = "var(--sun)", size = 56 }) {
  return (
    <div
      className="motif-smiley"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: color,
      }}
    ></div>
  );
}
